import { render, staticRenderFns } from "./ProfileInfo.vue?vue&type=template&id=7b1a857e&scoped=true&"
import script from "./ProfileInfo.vue?vue&type=script&lang=js&"
export * from "./ProfileInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1a857e",
  null
  
)

export default component.exports